module.exports = __webpack_public_path__ + "img/calimaya.cfd1dd04.jpg";